import { Link } from "wouter";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="container py-24 text-center">
      <div className="text-6xl font-bold text-brand-300">404</div>
      <h1 className="mt-4 text-2xl font-semibold">{t("common.notFound")}</h1>
      <Link href="/" className="btn-primary mt-6 inline-flex">
        {t("common.backHome")}
      </Link>
    </div>
  );
}
